import { gql } from '@apollo/client';
const GET_TENANT_PRODUCTS = gql `
  query GetTenantProducts(
    $first: Int
    $after: String
    $categoryId: [ID] = []
    $supplierId: [ID] = []
    $statusId: String = ""
    $name: String = ""
    $functionIds: [ID] = []
    $sustainabilityIds: [ID] = []
    $certificateIds: [ID] = []
    $continentIds: [ID] = []
    $countryIds: [ID] = []
    $eventIds: [ID] = []
    $mainCategoryIds: [ID] = []
  ) {
    me {
      id
      currentTenant {
        id
        products(
          first: $first
          after: $after
          name: $name
          categoryId: $categoryId
          supplierId: $supplierId
          status: $statusId
          functionIds: $functionIds
          sustainabilityIds: $sustainabilityIds
          certificateIds: $certificateIds
          continentIds: $continentIds
          countryIds: $countryIds
          eventIds: $eventIds
          mainCategoryIds: $mainCategoryIds
        ) {
          pageInfo {
            hasNextPage
            endCursor
          }
          edges {
            node {
              id
              name
              status
              pictures {
                edges {
                  node {
                    id
                    image
                  }
                }
              }
              supplier {
                id
                code
                shortName
                fullName
              }
              category {
                id
                type
                typeLabelPL
                typeLabelEN
                typeIcon
              }
              producerCode {
                name
              }
              productVariantsCount
              activeProductVariantsCount
            }
          }
        }
      }
    }
  }
`;
export default GET_TENANT_PRODUCTS;
